<h1 mat-dialog-title> Choisir option</h1>
<div mat-dialog-content>

  <form #selectForm="ngForm" class="select-form">

    <mat-form-field>
      <mat-label>{{data.label}}</mat-label>
      <mat-select required name="option" [(ngModel)]="selectedOption">
        @for (opt of data.options; track opt) {
          <mat-option [value]="opt" >{{opt}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

  </form>
</div>

<div mat-dialog-actions>
  <button class="simple-button" mat-button [mat-dialog-close]="">Annuler</button>
  <button class="simple-button" [disabled]="!selectForm.valid" mat-button [mat-dialog-close]="selectedOption" > Soumettre </button>
</div>